import { useCallback, useState } from 'react'

export const useToggle = (initialValue = false) => {
	const [value, setValue] = useState(initialValue)
	const toggle = useCallback((custom = null) => {
		setValue(v => (custom !== null ? custom : !v))
	}, [])
	return [value, toggle]
}
